export var FILTERS_TIMING_FETCH_START_KEY = "logged-in-category-page-filter-sections-fetch-start";
export var FILTERS_TIMING_FETCH_END_KEY = "logged-in-category-page-filter-sections-fetch-end";
export var LAYOUT_ELEMENTS_TIMING_FETCH_START_KEY = "logged-in-category-page-layout-elements-fetch-start";
export var LAYOUT_ELEMENTS_TIMING_FETCH_END_KEY = "logged-in-category-page-layout-elements-fetch-end";
export var PageLoadTimingSectionName;
(function(PageLoadTimingSectionName) {
    PageLoadTimingSectionName["FILTERS"] = "FILTERS";
    PageLoadTimingSectionName["LAYOUT_ELEMENTS"] = "LAYOUT_ELEMENTS";
})(PageLoadTimingSectionName || (PageLoadTimingSectionName = {}));
